<template>
  <div style="background: #f6f6f7">
    <pcHeaders></pcHeaders>
        <div style="display: flex;align-items: center;width: 100%;justify-content: center;flex-direction: column;">
          <div style="color: #e33737;font-size: 18px;width: 1352px;background-color: #fff;padding:10px 40px;">温馨提示：</div>
          <div style="color: #e33737;font-size: 18px;width: 1352px;background-color: #fff;padding:10px 40px;">1.本网站不开设医学类、财会类、档案类专业继续教育课程。有相关学习需求的学员，请自行联系对应行业主管部门，确认正确学习平台。若错选本网站并完成缴费，将不予退费。</div>
          <div style="color: #e33737;font-size: 18px;width: 1352px;background-color: #fff;padding:10px 40px;">2.申请发票前，请务必仔细核对开票信息。因个人信息填写错误导致发票开错的，不予更换。</div>

          <!-- <div style="color: #e33737;font-size: 18px;width: 1352px;background-color: #fff;padding:20px 40px;">因此费用为财政直缴，请大家谨慎选课并缴费，因本人错选、误选课程费用将不予退回</div> -->
          <div style="color: #e33737;font-size: 18px;width: 1352px;background-color: #fff;padding:10px 40px;">3.若支付成功后，显示订单为未支付，请勿操作，耐心等待30分钟左右。退出账号重新登录即可。</div>
        </div>
    <!-- <payorder :orderNo="orderNo"></payorder> -->
    <div id="class1"></div>
    <pcBottom></pcBottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';
import payorder from '../car/toPayOrder.vue';

import pcBottom from '../component/bottom.vue';
import $ from 'jquery';
import { toOrderConfirm, getOrderId,doOrderPrice } from '@/api/pay.js';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom,
    payorder
  },
  data() {
    // 这里存放数据
    return {
      calssInfo: {}, //订单核对数据
      paymentNum: 0, //实付金额
      merchantNo: '', //商户号
      orderNo: '', //订单id
      zyName: '',
      derateType: '',
      currentDate: '', // 存储当前日期
      userMobile: '',
      userName: '',
      userId:'',
      money:''
    };
  },

  mounted() {},
  created() {
    this.getPrice();
    this.getFormattedDate();

    this.loadThirdPayScript();
    const hasRefreshed = localStorage.getItem('hasRefreshed');
    if (!hasRefreshed) {
      // 如果没有刷新过，则设置标记并刷新页面
      localStorage.setItem('hasRefreshed', 'true');
      window.location.reload();
    } else {
      localStorage.removeItem('hasRefreshed');
    }
  },

  computed: {},
  methods: {
    getPrice(){
      doOrderPrice({orderNo:this.$route.query.orderNo}).then(res => {
          console.log(res.data,'000');
          
          this.money=res.data.data.money
          });
    },
    getFormattedDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      this.currentDate = `${year}-${month}-${day}`;
   
    },
    loadThirdPayScript() {
      const script = document.createElement('script');
      // script.src = 'https://debug.epayservice.cn/thirdpay/resources/widget/js/thirdpay_widget.js';//测试

      script.src = 'https://api.epayservice.cn/thirdpay/resources/widget/js/thirdpay_widget.js';//线上

      script.type = 'text/javascript';
      script.onload = () => {
        this.initThirdPayWidget();
      };
      document.head.appendChild(script);
    },
    initThirdPayWidget() {
      let that = this;
      setTimeout(() => {
        $(document).ready(function () {
          console.log(that.merchantNo, that.orderNo, that.paymentNum, that.$route.query.classIds, that.userId, '99');
          thirdpay_widget.init({
            container: 'class1',
            merchant_no: that.$route.query.merchantNo,
            merchant_order_no: that.$route.query.orderNo,
            amount:that.money * 100,
            charge_param: {
              classIds: that.$route.query.classIds,
              courseId: '',
              derateType: '02',
              orderNo: that.$route.query.orderNo,
              userId: that.$route.query.userId,
              oldFlag: '01'
            },
            widgetParam: {
              businessNo: that.$route.query.orderNo,
              regCode: '150295',
              businessType: '001',
              agencyCode: '214001',
              date: 'that.currentDate',
              payerName: 'that.userName',
              payerTel: 'that.userMobile',
              payeeAccAssignType: '1',
              totalAmt: that.money * 100,
              author: 'that.$route.query.userName',
              placeCode: '001',
              billCode: '0004',
              itemDetails: [
                {
                  itemCode: '103042789',
                  itemName: '成人教育学费',
                  unit: '人/次',
                  number: 1,
                  std: that.money * 100,
                  amt:that.money * 100
                }
              ]
            },
            subject: '向呼和浩特人事考试中心缴费"',
            body: '向呼和浩特人事考试中心缴培训费',

            charge_url: 'https://hhht.nmgrcw.com/api/order/toGenerateOrderNew.html',
            // charge_url: 'http://192.168.1.103:9092/order/toGenerateOrderNew.html',
            device_type: 'pc',
            version_no: '1.1'
          });
        });
      }, 1000);
    },
    // initThirdPayWidget() {
    //   let that = this;
    //   setTimeout(() => {
    //   $(document).ready(function () {
    //     console.log(that.merchantNo, that.orderNo, that.paymentNum,that.$route.query.classIds,that.userId, '99');
    //     thirdpay_widget.init({
    //       container:'class1',
    //       merchant_no: that.merchantNo,
    //       merchant_order_no: that.orderNo,
    //       amount: that.paymentNum * 100,
    //       charge_param: {
    //         classIds: that.$route.query.classIds,
    //         courseId: '',
    //         derateType: '02',
    //         orderNo: that.orderNo,
    //         userId: that.userId,
    //         oldFlag : '01'
    //       },
    //       widgetParam: {
    //         businessNo:that.orderNo,
    //               regCode: '150295',
    //               businessType: '001',
    //               agencyCode: '214001',
    //               date: 'that.currentDate',
    //               payerName: 'that.userName',
    //               payerTel: 'that.userMobile',
    //               payeeAccAssignType: '1',
    //               totalAmt: that.paymentNum * 100,
    //               author: 'that.userName',
    //               placeCode: '001',
    //               billCode: '0004',
    //               itemDetails: [
    //                 {
    //                   itemCode: '103042789',
    //                   itemName: '成人教育学费',
    //                   unit: '人/次',
    //                   number: 1,
    //                   std:that.paymentNum * 100,
    //                   amt:that.paymentNum * 100
    //                 }
    //               ]},
    //       subject: '向呼和浩特人事考试中心缴费"',
    //       body: '向呼和浩特人事考试中心缴培训费',
    //       charge_url: 'https://hhht.nmgrcw.com/api/order/toGenerateOrderNew.html',
    //       device_type: 'pc',
    //       version_no: '1.1'
    //     });
    //   });
    // }, 1000);

    // },
    // toOrderConfirm() {
    //   toOrderConfirm({ classIds: this.$route.query.classIds }).then(res => {
    //     console.log(res.data);
    //     if (res.data.data.code == '1') {
    //       this.calssInfo = res.data.data.data;
    //       this.paymentNum = this.calssInfo.totalPrice;
  
    // getOrderId({ classIds: this.$route.query.classIds,derateType: '02' }).then(res => {
    //   this.merchantNo = res.data.data.merchantNo;
    //   this.orderNo = res.data.data.orderNo;
    //   this.userId = res.data.data.userId;
    //   this.userMobile = res.data.data.userMobile;
    //   this.userName = res.data.data.userName;
    // });
    //     } else {
    //       this.$message(res.data.data.msg);
    //       this.$router.back();
    //     }
    //   });
    // }
  }
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
#class1 {
  height: 550px;
}
* {
  font-family: Regular;
}
::v-deep {
  #widget_thirdapy_bosssoft .tabbox_bank {
    width: 71%;
  }
  #widget_thirdapy_bosssoft .order {
    width: 71%;
    padding: 20px 40px;
  }
}
</style>
